const MudraLocation = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-6xl overflow-hidden rounded-[24px] shadow-[0_24px_70px_rgba(16,38,26,0.12)]">
                    <div className="aspect-[4/3] w-full sm:aspect-[16/9]">
                        <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5121.729786221659!2d80.01193900000001!3d6.366843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22bd90401f45f%3A0x336d9e1711b02194!2sHiru%20Mudra%20Ayurveda%20Resort!5e1!3m2!1sen!2slk!4v1787457104316!5m2!1sen!2slk"
    className="h-full w-full border-0"
    allowFullScreen
    loading="lazy"
    referrerPolicy="strict-origin-when-cross-origin"
    title="Standort von Hiru Mudra Ayurveda Resort"
  />
                    </div>
                </div>
            </div>
        </section>;
};
export default MudraLocation;
